import * as Types from '../../../gql/types';

import {gql} from '@apollo/client';
import {PosterDetailsFragmentDoc} from '../../../gql/fragments/poster-details';
import {PosterOptionsFragmentDoc} from '../../../gql/fragments/poster-options';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type SavePosterMutationVariables = Types.Exact<{
  posterId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  poster: Types.PosterInput;
}>;

export type SavePosterMutation = {
  __typename?: 'Mutation';
  savePoster?: {
    __typename?: 'SavePosterPayload';
    poster?: {
      __typename?: 'Poster';
      id: string;
      name: string;
      variant: Types.PosterVariant;
      activitiesStartDate: any;
      activitiesEndDate: any;
      activityTypes: Array<Types.ActivityType>;
      baseColor: any;
      highlightColor: any;
      image: {__typename?: 'Image'; url: any};
      options: {
        __typename?: 'PosterOptions';
        activityTypes: Array<Types.ActivityType>;
        colors: Array<any>;
      };
    } | null;
    errors: Array<{__typename?: 'Error'; message: string}>;
  } | null;
};

export const SavePosterDocument = gql`
  mutation savePoster($posterId: ID, $poster: PosterInput!) {
    savePoster(posterId: $posterId, poster: $poster) {
      poster {
        id
        ...posterDetails
        image(transform: ORIGINAL) {
          url
        }
        ...posterOptions
      }
      errors {
        message
      }
    }
  }
  ${PosterDetailsFragmentDoc}
  ${PosterOptionsFragmentDoc}
`;
export type SavePosterMutationFn = ApolloReactCommon.MutationFunction<
  SavePosterMutation,
  SavePosterMutationVariables
>;

/**
 * __useSavePosterMutation__
 *
 * To run a mutation, you first call `useSavePosterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePosterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePosterMutation, { data, loading, error }] = useSavePosterMutation({
 *   variables: {
 *      posterId: // value for 'posterId'
 *      poster: // value for 'poster'
 *   },
 * });
 */
export function useSavePosterMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SavePosterMutation,
    SavePosterMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    SavePosterMutation,
    SavePosterMutationVariables
  >(SavePosterDocument, options);
}
export type SavePosterMutationHookResult = ReturnType<
  typeof useSavePosterMutation
>;
export type SavePosterMutationResult =
  ApolloReactCommon.MutationResult<SavePosterMutation>;
export type SavePosterMutationOptions = ApolloReactCommon.BaseMutationOptions<
  SavePosterMutation,
  SavePosterMutationVariables
>;
